class UtilityValidationError extends Error {
  constructor(details) {
    super(UtilityValidationError.errorCode);
    this.details = details;
    this.errorCode = 'UTILITY_ERROR';
  }
}

export default UtilityValidationError;
